// Admin > Users (BUG-089): how many reports (grades) and tech specs each user has given.
// Counts come from venue_reports by userId; rejected submissions don't count. The old
// `user.reports` array on the user doc is no longer kept up to date, so it isn't used.

export function contributionCountsByUser(reports) {
  const counts = {};
  (Array.isArray(reports) ? reports : []).forEach((report) => {
    const uid = report && typeof report.userId === 'string' ? report.userId : '';
    if (!uid || report.status === 'rejected') return;
    const entry = counts[uid] || (counts[uid] = { reports: 0, techSpecs: 0 });
    if (report.isTechSpecsOnly) entry.techSpecs += 1;
    else entry.reports += 1;
  });
  return counts;
}

export function contributionCountsFor(counts, uid) {
  return (counts && uid && counts[uid]) || { reports: 0, techSpecs: 0 };
}
